import { render, staticRenderFns } from "./QuotaForm.vue?vue&type=template&id=047a35f4&scoped=true"
import script from "./QuotaForm.vue?vue&type=script&lang=js"
export * from "./QuotaForm.vue?vue&type=script&lang=js"
import style0 from "./QuotaForm.vue?vue&type=style&index=0&id=047a35f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a35f4",
  null
  
)

export default component.exports